import { PhoneNumber } from 'libphonenumber-js'
import { ExternalLink } from '@/atoms/ExternalLink'
import { ParagraphSM } from '@/atoms/Text'
import { useSafeAnalytics } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { ShowtimesVenue } from '../hooks/useVenueSearch/useVenueSearch'
import { TicketsAnalyticsPayload } from './TicketsContext'

interface ShowtimesWithNoUrlsStateProps {
  venue: ShowtimesVenue
  venuePhoneNumber: PhoneNumber | undefined
  analyticsPayload: TicketsAnalyticsPayload
}
const ShowtimesWithNoUrlsState = ({ venue, venuePhoneNumber, analyticsPayload }: ShowtimesWithNoUrlsStateProps) => {
  const { t } = useTranslate('tickets')
  const { track } = useSafeAnalytics()
  return (
    <div>
      <ParagraphSM color="black" weight="semibold" className="my-4">
        {t(
          'onlineTicketSalesNotAvailable',
          'Online ticket sales are not available at this theater. Contact this theater for ticket sales.',
        )}
      </ParagraphSM>
      {!!venuePhoneNumber && (
        <ExternalLink
          className="my-2 block xl:hidden"
          href={venuePhoneNumber.getURI()}
          onClick={() => {
            track('Tickets Venue Phone Number Clicked', analyticsPayload)
          }}
        >
          <ParagraphSM className="text-[11px] leading-4 text-core-gray-900 underline xl:text-right" weight="normal">
            {venuePhoneNumber.formatNational()}
          </ParagraphSM>
        </ExternalLink>
      )}
      {!!venue.url && (
        <ExternalLink
          className="my-2 block xl:hidden"
          href={venue.url}
          onClick={() => {
            track('Tickets Venue Website Clicked', analyticsPayload)
          }}
        >
          <ParagraphSM className="text-[11px] leading-4 text-blue-500 underline xl:text-right" weight="normal">
            {t('visitWebsite', 'Visit Website')}
          </ParagraphSM>
        </ExternalLink>
      )}
    </div>
  )
}

export default ShowtimesWithNoUrlsState
